module.exports = __webpack_public_path__ + "dc6bb7011b2bb83c94a270e0ccd8ba50.MP3";